import React from "react";
import "../StoragePages.scss";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import {
	BorderLine,
	Description,
	Heading,
	LastSearchBar,
	ListPoint
} from "components/storages/Common";
import { BOAT_STORAGE_DATA } from "components/storages/ContentData/BoatStorageData";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import { Paragraph } from "components/core/Typography";
import { useSelector } from "react-redux";
import { PAGE_SUB_TYPES } from "@sparefoot/tracking-events";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

function BoatStoragePage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	usePageViewTracking(PAGE_SUB_TYPES.BOAT_LANDING);

	return (
		<Page
			className="storage-page"
			pageType={PAGE_SUB_TYPES.BOAT_LANDING}
			title="Boat Storage - Rental Guide & Facility Search | Find & Rent Self Storage Units Near You - Storage.com "
			description="Keep your boat shipshape year-round! Find climate-controlled 
			boat storage on Storage.com. Protect your boat from the elements & 
			ensure its longevity."
			canonical={`${baseUrl}/boat-storage/`}
		>
			<Container>
				<StorageHeader
					heading="Find Boat Storage Near You!"
					level="1"
				/>
				<div className="all-sections">
					{BOAT_STORAGE_DATA?.map((item, index) => (
						<>
							<Heading
								content={item.heading}
								level={index === 0 ? 2 : 3}
							/>
							<Description desc={item.description} />
							<Description desc={item.description2} />
							{item.subHeadings &&
								item.subHeadings.map((subHeading) => (
									<>
										<Paragraph
											size="xlarge"
											weight="bold"
										>
											{subHeading.title}
										</Paragraph>
										<br />
										<Description desc={subHeading.desc} />
										<br />
										<Description desc={subHeading.desc2} />
									</>
								))}
							<ul>
								{item.points &&
									item.points.map((point) => (
										<ListPoint
											title={point.title}
											desc={point.desc}
										/>
									))}
							</ul>
							{item.subHeadings2 &&
								item.subHeadings2.map((subHeading) => (
									<>
										<Paragraph
											size="xlarge"
											weight="bold"
										>
											{subHeading.title}
										</Paragraph>
										<br />
										<Description desc={subHeading.desc} />
										<br />
										<Description desc={subHeading.desc2} />
									</>
								))}
							<br />
							<Description desc={item.description3} />

							{index !== BOAT_STORAGE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}
					<LastSearchBar />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default BoatStoragePage;
